import script from "./AlternadorDeRecurso.vue?vue&type=script&setup=true&lang=js"
export * from "./AlternadorDeRecurso.vue?vue&type=script&setup=true&lang=js"

import "./AlternadorDeRecurso.vue?vue&type=style&index=0&id=dc72af7c&scoped=true&lang=css"

import exportComponent from "/home/ewerson/Projetos/vue/vitrine_digital/vitrine-crescimentoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc72af7c"]])

export default __exports__